import { SocialProvider } from '@dtx-company/true-common/src/types/socialProvider'
import { UseAuthFormHeapEventsReturnType } from './auth-form.types'
import { fireHeapEvent } from '@dtx-company/inter-app/src/event-tracking/helpers'
import { useCallback } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { useRouter } from 'next/router'
import flowpageEvents from '@dtx-company/inter-app/src/event-tracking/events/flowpage'
import taggingEvents from '@dtx-company/inter-app/src/event-tracking/events/tagging'

export const useAuthFormHeapEvents = (): UseAuthFormHeapEventsReturnType => {
  const { pathname: path } = useRouter()

  const userTypedInAuthFormEmailField = useDebouncedCallback(() => {
    flowpageEvents.userTypedInAuthFormEmailField()
  }, 500)

  const userTypedInAuthFormPasswordField = useDebouncedCallback(() => {
    flowpageEvents.userTypedInAuthFormPasswordField()
  }, 500)

  const userFocusedAuthFormField = useCallback((isSignIn: boolean, fieldName: string): void => {
    if (isSignIn) {
      fireHeapEvent('Core_SignIn_Focused_TextField', { textField: fieldName })
    } else {
      fireHeapEvent('Core_SignUp_Focused_TextField', { textField: fieldName })
    }
  }, [])

  const userClickedAuthFormAuthenticateWithSocial = useCallback(
    (socialProvider: SocialProvider) => {
      flowpageEvents.userClickedAuthFormAuthenticateWithSocial(socialProvider)
    },
    []
  )

  const userClickedAuthFormForgotPassword = useCallback(() => {
    flowpageEvents.userClickedAuthFormForgotPassword()
  }, [])

  const userCheckedAuthFormIAgreeToTermsAndConditions = useCallback(() => {
    flowpageEvents.userCheckedAuthFormIAgreeToTermsAndConditions()
    taggingEvents.Revenue_SignUpPage_Clicked_TermsAndConditionsCheckbox()
  }, [])

  const userClickedAuthFormTermsAndConditionsLink = useCallback(() => {
    flowpageEvents.userClickedAuthFormTermsAndConditionsLink()
  }, [])

  const userClickedAuthFormSubmitButton = useCallback(
    (options?: { sso?: boolean }) => {
      flowpageEvents.userClickedAuthFormSubmitButton({
        path,
        sso: String(options?.sso || false)
      })
    },
    [path]
  )

  return {
    userTypedInAuthFormEmailField,
    userTypedInAuthFormPasswordField,
    userFocusedAuthFormField,
    userClickedAuthFormAuthenticateWithSocial,
    userClickedAuthFormForgotPassword,
    userClickedAuthFormSubmitButton,
    userCheckedAuthFormIAgreeToTermsAndConditions,
    userClickedAuthFormTermsAndConditionsLink
  }
}
